import React from "react";
import { Link } from "gatsby";
import { colors } from "~/utils/colors";
import { breakPoints } from "~/utils/variables";
import ThumbsBlankJpg from "~/images/thumbBlank.jpg";

interface Props {
  article: GatsbyTypes.ContentfulDownload;
  href: string;
}

export const DownloadCard: React.FC<Props> = ({ article, href }) => {
  const { title, documentCover, shortDescription } = article;

  return (
    <>
      <li className="card">
        <Link to={href}>
          <div className="cover" />
          <div className="body">
            <h2 className="title">{title}</h2>
            {shortDescription && <div className="shortDescription">{shortDescription}</div>}
          </div>
        </Link>
      </li>
      <style jsx>{`
        .card {
          background-color: ${colors.white};
          border: 1px solid ${colors.gray3};
          border-radius: 8px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          margin: 15px;
          overflow: hidden;
          transition: box-shadow 0.3s ease;
          width: calc(100% / 3 - 30px);
        }
        .card:hover {
          box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);
        }
        .card:hover .cover {
          opacity: 0.8;
        }
        .cover {
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          background-image: url(${documentCover?.fluid?.src || ThumbsBlankJpg});
          border-radius: 8px 8px 0 0;
          padding-top: 52.5%;
          transition-property: background-size, opacity;
          transition-duration: 0.4s;
          transition-timing-function: ease;
          width: 100%;
          height: 0;
        }
        .body {
          color: ${colors.defaultText};
          padding: 20px 24px 20px;
        }
        .title {
          color: ${colors.black};
          font-size: 16px;
          font-weight: 700;
          letter-spacing: 0.02em;
          line-height: 1.4;
          margin: 0 0 8px;
        }
        .shortDescription {
          font-size: 14px;
          font-weight: 400;
          letter-spacing: 0.015em;
          line-height: 1.5;
          margin: 0;
        }
        @media (${breakPoints.sp}) {
          .card {
            width: 100%;
            margin: 15px 0;
          }
        }
      `}</style>
    </>
  );
};
